export const HEADER_HEIGHT_SMALL = 50;
export const HEADER_HEIGHT_TALL = 158;
export const BACKDROP_Z_INDEX = 20;
export const TOGGLE_BUTTON_SIZE = 50;
export const INPUT_SIZE = 44;
export const BUTTON_SIZE = INPUT_SIZE;
export const SEARCH_BAR_HEIGHT = 36;
//# sourceMappingURL=constants.js.map